import React from "react";
import moment from "moment";
import { Popover } from 'antd';
import styled from "styled-components";
import SeverityTag from "../../../../Tags/SevertiyTag";

export const tabs = [
  {
    key: 'localisedIncidents',
    label: 'Localised Incidents',
  },
  {
    key: 'correctiveActions',
    label: 'Corrective Actions',
  },
];

const PopoverStyle = styled.div`
  max-width: 250px;

  h3 {
    font-size: 12px;
    font-weight: 700;
    color: #667085;
    margin-bottom: 8px;
  }

  .labels {
    display: flex;
    flex-direction: column;
    gap: 4px;

    label {
      font-size: 12px;
      font-weight: 400;
      color: #667085;
      margin-bottom: 0px;
    }
  }
`;

const SinglePopoverStyle = styled.div`
  max-width: 200px;
`;

export const incidentsColumns = ({ t, options, language, contRef }) => {
  const getPopupContainer = () => contRef?.current;
  return [
    {
      title: (
        <Popover
          content={<SinglePopoverStyle>{t('ID')}</SinglePopoverStyle>}
          {...getPopupContainer()}
        >
          {t('ID')}
        </Popover>
      ),
      dataIndex: 'datastakeId',
      key: 'datastakeId',
      width: 155,
      ellipsis: true,
    },
    {
      title: t('Associated Risk'),
      dataIndex: 'associatedRisk',
      ellipsis: true,
      key: 'associatedRisk',
      render: (v) => {
        if (Array.isArray(v) && v.length) {
          const { associatedRiskOptions = [] } = options;
          if (v.length === 1) {
            const _val = associatedRiskOptions.find((o) => o.value === v[0]);

            if (_val) {
              const _v = _val.label[language] || _val.label.en;
              return (
                <Popover
                  {...getPopupContainer()}
                  content={<SinglePopoverStyle>{_v}</SinglePopoverStyle>}
                  placement="topLeft"
                >
                  {_v}
                </Popover>
              );
            }
          }

          return (
            <Popover
              placement="topLeft"
              {...getPopupContainer()}
              content={(
                <PopoverStyle>
                  <h3>{t('Associated Risk')}</h3>
                  <div className="labels">
                    {v.map((_v, i) => {
                      const _val = associatedRiskOptions.find((o) => o.value === _v);

                      if (_val) {
                        return (
                          <label key={`${v}-${i}`}>
                            {_val.label[language] || _val.label.en}
                          </label>
                        )
                      }

                      return '';
                    })}
                  </div>
                </PopoverStyle>
              )}
            >
              <div className="more-tag">
                <div className="label flex-c jus-c">

                  {t('Risks')}
                </div>
                <div className="value">
                  {v.length}
                </div>
              </div>
            </Popover>
          )
        }
      },
      width: 140,
    },
    {
      title: t('Title'),
      dataIndex: 'eventTitle',
      key: 'eventTitle',
      ellipsis: true,
      render: (val) => (
        <Popover
          {...getPopupContainer()}
          content={<SinglePopoverStyle>{val}</SinglePopoverStyle>}
        >
          {val}
        </Popover>
      ),
      width: '25%',
    },
    {
      title: t('Location'),
      dataIndex: 'locationName',
      key: 'locationName',
      ellipsis: true,
      render: (val) => (
        <Popover
          {...getPopupContainer()}
          content={<SinglePopoverStyle>{val}</SinglePopoverStyle>}
        >
          {val}
        </Popover>
      ),
    },
    {
      title: t('Date'),
      dataIndex: 'dateOfEvent',
      key: 'dateOfEvent',
      render: (date) => date ? moment(date).format('DD MMM Y') : (
        <span style={{ opacity: 0, userSelect: 'none' }}>_</span>
      ),
      width: 130,
    },
    {
      title: t('Source'),
      dataIndex: 'source',
      key: 'source',
      ellipsis: true,
      render: (val) => <Popover
        content={(
          <SinglePopoverStyle>{val?.name}</SinglePopoverStyle>
        )}
        {...getPopupContainer()}
      >
        {val?.name}
      </Popover>,
    },
    {
      title: t('Severity'),
      dataIndex: 'incidentSeverity',
      key: 'incidentSeverity',
      ellipsis: true,
      render: (val) => val ? (
        <SeverityTag t={t} value={val} />
      ) : null,
      width: 120,
    },
  ]
};

// associatedRisk
// typeOfAction
export const correctiveActions = ({ t, language, options, contRef }) => {
  const getPopupContainer = () => contRef?.current;
  return [
    {
      title: (
        <Popover
          {...getPopupContainer()}
          content={<SinglePopoverStyle>{t('ID')}</SinglePopoverStyle>}
        >
          {t('ID')}
        </Popover>
      ),
      dataIndex: 'datastakeId',
      key: 'datastakeId',
      width: 140,
    },
    {
      title: t('Title'),
      dataIndex: 'eventTitle',
      key: 'eventTitle',
      ellipsis: true,
      render: (val) => <Popover
        {...getPopupContainer()}
        content={<SinglePopoverStyle>{val}</SinglePopoverStyle>}
      >
        {val}
      </Popover>,
      width: '25%',
    },
    {
      title: t('Action Type'),
      dataIndex: 'typeOfAction',
      key: 'typeOfAction',
      ellipsis: true,
      render: (val) => {
        const { recommendedMeasureOptions = [] } = options;
        const _val = recommendedMeasureOptions.find((o) => o.value === val);

        if (_val) {
          const _v = _val.label[language] || _val.label.en;
          return (
            <Popover
              {...getPopupContainer()}
              content={<SinglePopoverStyle>{_v}</SinglePopoverStyle>}
              placement="topLeft"
            >
              {_v}
            </Popover>
          );
        }
      }
    },
    {
      title: t('Associated Risks'),
      dataIndex: 'associatedRisk',
      key: 'associatedRisk',
      ellipsis: true,
      render: (v) => {
        if (Array.isArray(v) && v.length) {
          const { riskSubcategoriesOptions = [] } = options;
          if (v.length === 1) {
            const _val = riskSubcategoriesOptions.find((o) => o.value === v[0]);

            if (_val) {
              const _v = _val.label[language] || _val.label.en;
              return (
                <Popover
                  {...getPopupContainer()}
                  content={<SinglePopoverStyle>{_v}</SinglePopoverStyle>}
                  placement="topLeft"
                >
                  {_v}
                </Popover>
              );
            }
          }

          return (
            <div className="more-tag">
              <div className="label flex-c jus-c">
                <Popover
                  {...getPopupContainer()}
                  placement="topLeft"
                  content={(
                    <PopoverStyle>
                      <h3>{t('Associated Risk')}</h3>
                      <div className="labels">
                        {v.map((_v, i) => {
                          const _val = riskSubcategoriesOptions.find((o) => o.value === _v);

                          if (_val) {
                            return (
                              <label key={`${v}-${i}`}>
                                {_val.label[language] || _val.label.en}
                              </label>
                            )
                          }

                          return '';
                        })}
                      </div>
                    </PopoverStyle>
                  )}
                >
                  {t('Risks')}
                </Popover>
              </div>
              <div className="value">
                {v.length}
              </div>
            </div>
          )
        }
      },
    },
    {
      title: t('Location'),
      dataIndex: 'locationName',
      key: 'locationName',
      ellipsis: true,
      render: (val) => (
        <Popover
          {...getPopupContainer()}
          content={<SinglePopoverStyle>{val}</SinglePopoverStyle>}
        >
          {val}
        </Popover>
      ),
    },
    {
      title: t('Date'),
      dataIndex: 'dateOfEvent',
      key: 'dateOfEvent',
      render: (date) => date ? moment(date).format('DD MMM Y') : (
        <span style={{ opacity: 0, userSelect: 'none' }}>_</span>
      ),
      width: 130,
    },
    {
      title: t('Author'),
      dataIndex: 'source',
      key: 'source',
      ellipsis: true,
      render: (val) => (
        <Popover
          {...getPopupContainer()}
          content={<SinglePopoverStyle>{val?.name}</SinglePopoverStyle>}
        >
          {val?.name}
        </Popover>
      ),
    },
  ];
}
